import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import firebase from '../../firebase.js';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Transition } from 'react-transition-group';

import Logo from '../../../../assets/Logo.png';
import LoadingState from '../../../../modules/LoadingState/index.js';
import { BASE_URLS } from '../../../constants';

import {
  Title,
  ContactLink,
  IntroText,
  LogoStyle,
  InputText,
  Form,
  LinksContainer,
  Button,
} from './styled';

const LoginForm = ({ gameSubmit }) => {
  const { register, handleSubmit } = useForm();
  const [active, LoaderHandler] = useState(false);

  // useEffect(() => {
  //   getADocByWhereClause();
  // }, []);

  // const getADocByWhereClause = async () => {
  //   try {
  //     //delete by where clause
  //     let deleteRef = firebase
  //       .firestore()
  //       .collection('players')
  //       .where('login', '==', '');
  //     let batch = firebase.firestore().batch();

  //     deleteRef.get().then((snapshot) => {
  //       snapshot.docs.forEach((doc) => {
  //         batch.delete(doc.ref);
  //       });
  //       return batch.commit();
  //     });
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  const onSubmit = (data) => {
    if (data.secureCode === '') {
      LoaderHandler(true);

      const playersRef = firebase.firestore().collection('players');
      const logincode = Number(data.LoginCode);
      playersRef
        .where('login', '==', logincode)
        .get()
        .then(function (querySnapshot) {
          if (querySnapshot.empty) {
            //hier zijn de inloggegegevens niet bekend
            toast('Inloggegevens zijn niet bekend');
            LoaderHandler(false);
          } else {
            //hier zijn de inloggegevens bekend
            querySnapshot.forEach(function (doc) {
              //maak een variabele voor het nu moment

              const now = moment().format();
              const game = doc.data();

              if (game.hasOwnProperty('deadline')) {
                //@vergelijk het nu, met de deadline van de game die is opgehaald.
                // console.log('game has property of deadline')
                if (moment(now).isAfter(game?.deadline)) {
                  console.log('het spel is verlopen');

                  LoaderHandler(false);
                  toast(
                    'Je spel is verlopen en kan niet meer gespeeld worden.'
                  );
                  return null;
                } else {
                  //@hier kun je inloggen maar hoeft er geen nieuwe deadline in te zitten
                  // console.log('succesvol ingelogd en er is geen nieuw deadline object gezet')

                  const documentId = doc?.id;
                  gameSubmit(game, documentId);
                  LoaderHandler(false);
                }
              } else {
                // @hier is de eerste speler ingelogged.
                const deadline = moment().add(72, 'hours').format();
                const documentId = doc.id;

                gameSubmit(game, documentId);
                LoaderHandler(false);

                playersRef.doc(doc.id).update({
                  gameStarted: true,
                  gameStartedDate: now,
                  deadline: deadline,
                });
              }
            });
          }
        })
        .catch(function (error) {
          toast(
            'Er heeft een probleem plaatsgevonden op de server. Probeer het later nog een keer'
          );
          LoaderHandler(false);
        });
    } else {
      toast(
        'Er heeft een probleem plaatsgevonden op de server. Probeer het later nog een keer'
      );
      LoaderHandler(false);
    }
  };

  // experiment
  // const onSubmit = (data) => {
  //   const now = moment().format();
  //   const game = "game";

  //   if (game.hasOwnProperty("deadline")) {
  //     //@vergelijk het nu, met de deadline van de game die is opgehaald.
  //     // console.log('game has property of deadline')
  //     if (moment(now).isAfter(game.deadline)) {
  //       console.log("het spel is verlopen");

  //       LoaderHandler(false);
  //       toast("Je spel is verlopen en kan niet meer gespeeld worden.");
  //       return null;
  //     } else {
  //       //@hier kun je inloggen maar hoeft er geen nieuwe deadline in te zitten
  //       // console.log('succesvol ingelogd en er is geen nieuw deadline object gezet')

  //       const documentId = 123;
  //       gameSubmit(game, documentId);
  //       LoaderHandler(false);
  //     }
  //   } else {
  //     // @hier is de eerste speler ingelogged.
  //     const deadline = moment().add(72, "hours").format();
  //     const documentId = 123;

  //     gameSubmit(game, documentId);
  //     LoaderHandler(false);

  //     // playersRef.doc(doc.id).update({
  //     //   gameStarted: true,
  //     //   gameStartedDate: now,
  //     //   deadline: deadline,
  //     // });
  //   }
  // };

  return (
    <Transition timeout={4000} in={true} appear>
      {(status) => (
        <div className={`box box-${status}`}>
          <LogoStyle src={Logo} alt='Logo' />
          <Title> in de Online game omgeving!</Title>
          <IntroText>
            Zit je er klaar voor? Zijn alle sanitaire stops gedaan? Zijn de
            drankjes gevuld? Heel belangrijk want je bent op dit moment slechts
            één stap verwijderd van het starten van het spel. En wanneer je
            eenmaal gestart bent… is er geen weg meer terug.
          </IntroText>
          <br />
          <IntroText>
            Leg het spel dat je ontvangen hebt op tafel en voor zover je dat nog
            niet hebt gedaan: open de doos. Pak alleen het bovenste papier
            eruit. Hierop vind je de spelregels en jouw unieke inlogcode. Lees
            de spelregels goed door. Als jij en je team er klaar voor zijn is
            het tijd om de code in te vullen en op de knop verzenden te drukken.
            Het spel start!
          </IntroText>
          <br />
          <IntroText>
            Let op! Jouw unieke inlogcode is slechts één keer te verzilveren.
            Voer de code pas in zodra jullie echt klaar zijn om te spelen.
          </IntroText>
          {active ? (
            <LoadingState />
          ) : (
            <Form onSubmit={handleSubmit(onSubmit)}>
              <InputText
                type='text'
                placeholder='LoginCode'
                name='LoginCode'
                ref={register({
                  required: true,
                  max: 16,
                  min: 8,
                  message: 'Invullen van een inlogcode is verplicht',
                  maxLength: 100,
                })}
              />
              <input
                type='text'
                placeholder='secure'
                name='secureCode'
                className='secureCode'
                ref={register({ required: false })}
              />
              <Button type='submit'>Verzenden</Button>
            </Form>
          )}
          <LinksContainer>
            <ContactLink
              href={`${BASE_URLS.HUISARREST_BASE_URL}/#veel_gestelde_vragen`}
              target='_blank'
              className='intro-link'
            >
              Waar vind ik mijn speelcode?
            </ContactLink>
            <ContactLink
              href={`${BASE_URLS.HUISARREST_BASE_URL}/contact`}
              target='_blank'
              className='intro-link'
            >
              Neem contact op
            </ContactLink>
          </LinksContainer>
        </div>
      )}
    </Transition>
  );
};

export default LoginForm;
